<template>
    <b-form-row>
        <b-modal @hidden="cancelar" v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer
            :id="this.id" :title="prefix + title">
            <usuario-list :pessoa="pessoa" :prefix="prefix" @onselect="handleSelect" />
        </b-modal>
        <lg-form-input-finder v-if="!isModal" v-model="localValue" fieldDescription="nome" :label="label"
            :disabled="disabled" :showClear="!disabled" invalidFeedback="Usuário deve ser informado!" description=""
            @handleClean="handleSelect">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" v-if="!disabled">
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import UsuarioList from "@/modules/gerenciamento/usuario/UsuarioList.vue";

export default {
    components: { LgFormInputFinder, UsuarioList },

    props: {
        isModal: {
            type: Boolean,
            default: false
        },
        pessoa: {
            type: Number,
            default: null
        },
        id: String,
        value: Object,
        prefix: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: "Usuário"
        },
        label: {
            type: String,
            default: "Usuário:"
        },
        disabled: {
            type: Boolean,
            default: false,
        }

    },

    data() {
        return {
            showModal: this.isModal,
            localValue: this.value,
            fields: [
                {
                    key: "action",
                    label: " ",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
                {
                    key: "nome",
                    label: "Nome",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        };
    },

    methods: {
        async show() {

            this.showModal = true;
            await this.$refs.finder.show();
            this.$bvModal.show(this.id);
        },

        cancelar() {
            this.$emit("close")
        },
        async handleSelect(item) {

            this.localValue = item;
            this.$emit("onselect", item);
            await this.$bvModal.hide(this.id);
        },

    },
};
</script>
